import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reaxl';
import ProfileContainer from '../ProfileContainer';
import HeaderBadgeMenuLinks from '../HeaderBadgeMenuLinks';
export function PopoverHeader(_ref) {
  let {
    navItems = {},
    headerNavItems = [],
    profile,
    onLogOut = () => {}
  } = _ref;
  const {
    logOutCTA
  } = navItems;
  const {
    label,
    ...logOutCTAProps
  } = logOutCTA;
  const handleLogOut = e => {
    onLogOut(e, logOutCTA);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(ProfileContainer, {
    profile: profile
  }), /*#__PURE__*/_jsx("ul", {
    className: "nav header-badge-links"
  }, void 0, headerNavItems.map(item => /*#__PURE__*/_jsx(HeaderBadgeMenuLinks, {
    navItem: item
  }, item.label))), /*#__PURE__*/React.createElement(Button, Object.assign({
    bsSize: "small",
    block: true,
    onClick: handleLogOut,
    className: "margin-top-5"
  }, logOutCTAProps), label));
}